export default __webpack_public_path__ + "static/media/colspase.8815dfcb.png";